<template>
  <section class="siglepage-container">
    <div
      v-for="(item, index) in qlist"
      :id="`form-${item.title_num}`"
      :key="item.title_num"
    >
      <component
        class="q-item"
        :index="index"
        :titleNo="item.title_num"
        :isRequired="item.is_required === 1"
        :question="item"
        :isShowNumber="qdata.is_show_question_number"
        :is="compsMap[item.subject_type]"
        @change="handleChange"
        :answer_json="answer_json"
        v-if="!allHideList.includes(item.title_num)"
      ></component>
    </div>
    <div
      class="
        go-answer
        c-white
        bg-hll-orange
        f-16
        flex flex-align-center flex-justify-center
      "
      @click="handleSubmit"
    >
      提交问卷
    </div>
  </section>
</template>

<script>
import QuestionMixin from './mixin/question-mixin.js';

export default {
  name: 'SinglePageQuestion',
  // 此页面逻辑全部交由mixin处理和多页展示形式共用mixin
  mixins: [QuestionMixin],
};
</script>

<style lang="less" scoped>
.siglepage-container {
  padding-bottom: 44px;
  .q-item {
    margin-top: 40px;
    &:first-child {
      margin-top: 26px;
    }
  }
  .go-answer {
    margin-top: 40px;
    height: 44px;
    border-radius: 8px;
  }
}
</style>
